var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    attrs: {
      "value": _vm.Sampling.value
    }
  }, [_c('v-container', [_c('top-image', {
    attrs: {
      "tit": _vm.Sampling.text,
      "bgImage": "/images/sub/product/sampling-bg.jpg",
      "image": "/images/sub/product/sampling-img.jpg"
    }
  }, [_c('p', {
    staticClass: "page-text mb-6 mb-lg-20"
  }, [_vm._v(" 케이아이이 시스템즈의 전처리(샘플링) 시스템은 최고 수준의 성능과 정확성을 제공하도록 설계되어 있으며, 고객의 공정 샘플이 최적의 상태로 준비되어 분석되도록 보장합니다. 엄격한 규제 요건을 충족해야 하거나 복잡한 샘플을 처리해야 하는 경우에도 당사의 전처리(샘플링) 시스템을 사용자화하여 특정 요구 사항을 충족하고 필요한 결과를 제공할 수 있습니다. ")]), _c('p', {
    staticClass: "page-text"
  }, [_vm._v(" 전처리(샘플링) 시스템은 질량 분석기, 가스 크로마토그래피 및 기타 다양한 온라인 분석기와 함께 사용 가능합니다. 이를 통해 원활한 샘플 준비 및 분석이 가능하며, 고품질의 데이터와 정확한 결과를 얻을 수 있습니다. ")])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }